import React ,{useRef ,useEffect}from 'react';
import './voucher.scss'
import IrtizaDynamicInputList from '../software-dynamic-version-3/list-input-v-3';
import moment from 'moment'
import SecurityService from '../security/security.service';
import VoucherService from './voucher.service';
import VoucherAdd from './voucher-add';
import AuditTableInput from '../audit-table/audit-table'
// import VoucherReport from '../reports/voucher/voucher';
// import { renderToStream ,pdf} from '@react-pdf/renderer';s

// import { saveAs } from 'file-saver'
let gridDetails  = []

const VoucherInput = (props) => {
console.log(props)
useEffect(() => {
  
  console.log(SecurityService.getLoggedInShopID())
  return () => {
    
  };
}, []);

    let columns =[
        {  field: "MainVoucherID",headerText:'ID',width:'120px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "VoucherID",headerText:'Voucher ID',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "VoucherDate",headerText:'Voucher Date',width:'130px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "AccountTitleCashBank",headerText:'Account Title Cash Bank',width:'160px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:props.Type != 'JV'}]},
        {  field: "TotalDebit",headerText:'Total Debit',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:props.Type != 'RV','format':'n0'}]},
        {  field: "TotalCredit",headerText:'Total Credit',width:'160px',textAlign:'right' ,headerTextAlign:'center',other:[{visible:props.Type != 'PV','format':'n0'}]},

       ]
       const getDetails = (e)=>{
        gridDetails = [...e]
       }
       const listActionComplete = async (grid ,args ,getListService ,selectedRow )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }

        if (args.requestType == 'save' ) {
          console.log(args)
          if(args.data.MainVoucherID){
          const response = await VoucherService.editVoucher({...args.data , AccountIDCashBank:props.Type == 'JV' ? null : args.data.AccountIDCashBank });
          console.log(response)
          await getListService()
          }else{
            console.log(gridDetails)
            if(gridDetails.length > 0 ){
              const data = {
                      MainVoucherID: args.data.MainVoucherID,
                      CompanyID: args.data.CompanyID,
                      VoucherID: args.data.VoucherID,
                      VoucherType: args.data.VoucherType,
                      VoucherDate: args.data.VoucherDate,
                      AccountIDCashBank: props.Type == 'JV' ? null : args.data.AccountIDCashBank,
                    
                      // Map updateDetails to details array, adding common properties to each item
                      details: [...gridDetails],
                    
                      // Nested params object
                      // params: {
                      //   FromDate: '01-JAN-01',
                      //   ToDate: moment().add(1, 'days').format('DD-MMM-YY'),
                      //   VoucherType: props.Type,
                      //   MainVoucherID: args.data.MainVoucherID,
                      //   VoucherID: 0,
                      //   AccountIDCashBank: 0,
                      //   AccountID: 0,
                      //   PurchaseInvoiceID: 0,
                      //   SaleInvoiceID: 0,
                      //   VoucherDetailID: 0
                      // }
                    };
                    
                    let response = await VoucherService.addVoucher(data)
                    console.log(response);
                    await getListService()

            }
          }
            // VoucherService.insert({...args.data,ShopID:SecurityService.getLoggedInShopID(), CreatedByUserID:SecurityService.getLoggedInUserId()}).then((res)=>{
            //   console.log(res)
              
            //   getListService()
            //   let AddData = {
            //     VoucherID:args.data.VoucherID,
            //     VoucherDate:args.data.VoucherDate,
            //     ShopName:args.data.ShopName,
            //     ShopNameFrom:args.data.ShopNameFrom,  
            //     ShopNameTo:args.data.ShopNameTo,
            //     AmountFrom:args.data.AmountFrom,
            //     AmountTo:args.data.AmountTo,
            //     ExchangeRate:args.data.ExchangeRate 
            //   }
            //   AuditTableInput.auditAdd(`Voucher`,`Voucher`,`MainVoucherID`,AddData)
            //   })
          
        }
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = false
    let  allowGridSum = true

       
        // Defines the  string
        // @default Voucher${typeMode} 
        let ListSecurity= props.Type  == 'JV' ? 'Journal Voucher': props.Type  == 'RV' ? 'Receipt Voucher': 'Payment Voucher'
        let AddSecurity= props.Type  == 'JV' ? 'Journal Voucher': props.Type  == 'RV' ? 'Receipt Voucher': 'Payment Voucher'
        let EditSecurity= props.Type  == 'JV' ? 'Journal Voucher': props.Type  == 'RV' ? 'Receipt Voucher': 'Payment Voucher'
        let DeleteSecurity= props.Type  == 'JV' ? 'Journal Voucher': props.Type  == 'RV' ? 'Receipt Voucher': 'Payment Voucher'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      //  let ReportSecurity= props.Type  == 'JV' ? 'Journal Voucher': props.Type  == 'RV' ? 'CashReceiptPreview': 'CashPaymentPreview'
      //  let toolbarOptions =['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser',{
      //     text: "Preview Voucher", tooltipText: "Preview Voucher", id: "VoucherReport", 
      //     disabled: !SecurityService.canUserAccess(ReportSecurity)
      //     ,mustSelectRow:true
          
      //  }];
      
      // Defines the toolbarClicking  function
      const ToolbarClicking = (grid,args)=>{
        console.log(grid)
        console.log(args)
        // if(args.item.properties.id == 'VoucherReport' && grid.selectedRowIndex != -1){
        //   console.log(args.item.properties.id)
        //   console.log(grid.getSelectedRecords()[0])
        //   handleRedirectVoucher(grid.getSelectedRecords()[0])
        
        // }
      }
      // const handleRedirectVoucher = (args) => {
      //   // Destructure parameters from the args object
      //   const {
      //     VoucherType,
      //     MainVoucherID,
      //     VoucherID,
      //     AccountIDCashBank,
      //     CurrencyID,
      //     MainInvoiceID,
      //     ShopID,
      //     VoucherCategory,
      //     AccountID,
      //     VoucherDetailID,
      //     VoucherDate
      //   } = args;
      //   console.log(args)
      //   console.log(VoucherType)
      //   // Construct the URL with the parameters
      //   const url = `/ReportVoucher${VoucherType}/${VoucherDate}/${VoucherType}/${MainVoucherID}/${VoucherID}/${AccountIDCashBank}/${CurrencyID}/${MainInvoiceID}/${ShopID}/${VoucherCategory}/${AccountID}/${VoucherDetailID}`;
      
      //   // Open the URL in a new tab and focus on it
      //   const newTab = window.open(url, '_blank');
      //   newTab.focus();
      // };
      
//       const handleRedirectVoucher = async (args) => {
//         // Destructure parameters from the args object
//         const {
//           VoucherType,
//           MainVoucherID,
//           VoucherID,
//           AccountIDCashBank,
//           CurrencyID,
//           MainInvoiceID,
//           ShopID,
//           VoucherCategory,
//           AccountID,
//           VoucherDetailID,
//           VoucherDate
//         } = args;
        
//     let data = {
//       FromDate: '01-JAN-01',
//       ToDate: moment(VoucherDate).format('DD-MMM-YY'),
//       VoucherType: VoucherType,
//       MainVoucherID:0,
//       VoucherID: 0,
//       AccountIDCashBank: 0,
//       CurrencyID: 0,
//       MainVoiceID: 0,
//       ShopID: ShopID,
//       VoucherCategory: '',
//       AccountID: 0,
//       VoucherDetailID: 0,
//     };
//     let response = await VoucherService.getGridDataSource(data);
// console.log(response.data.recordset)
// exportPdfFile(response.data.recordset ,VoucherType)


//       };
      
// const  exportPdfFile = async (data , type) =>{
  
//   //   const asPdf = pdf([]); // Creating a new PDF instance
//   //   let component =<VoucherReport
//   //   DataSource={data} 
//   //   VoucherType={type} 
//   //   />;
//   //   asPdf.updateContainer(component); // Upda te the container with the document

//   // const blob = await asPdf.toBlob(); // Generate the PDF as a Blob
//   // saveAs(blob, `Voucher${type}.pdf`);


// }
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Voucher' ,
                    TableID:'VoucherID',
                   // Optional if Delete is Soft // TableSecurity:'VoucherDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Voucher' ,TableID:'VoucherID', Optional // TableSecurity:'VoucherDelete'}]
    let listDelete = [{TableName:['VoucherDetail','Voucher'] ,TableID:['MainVoucherID']}];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <IrtizaDynamicInputList
        Id='Voucher'
        ListTitle={`${props.Type == 'JV' ? `Journal Voucher` : props.Type == 'RV' ? `RECEIPT VOUCHER` : `PAYMENT VOUCHER` }  ${props.ListType} - List`}
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        // DataSource:  ()=> VoucherService.getVoucherForList(SecurityService.getLoggedInShopID())
                        DataSource:  ()=> VoucherService.getVoucherForList(SecurityService.getCompanyIDLoggedInUserId() ,props.Type , props.ListType)
                        }]}
        DefaultSortedColumnName={'MainVoucherID'}
        GridDialog={[
            {
                DialogType:'Self',
                
                Dialog:<VoucherAdd  UserID={SecurityService.getLoggedInUserId()} Type={props.Type} CompanyID={SecurityService.getCompanyIDLoggedInUserId()}sendDetail={getDetails}  />
                }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking={ToolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            // AllowTemplate={allowTemplate}
            ToolbarOption={'All'}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
             // DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            ListDelete={listDelete}
            DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            HeadTitle={`${props.Type == 'JV' ? `JOURNAL VOUCHER` : props.Type == 'RV' ? `RECEIPT VOUCHER` : `PAYMENT VOUCHER` }   ${props.ListType.toUpperCase()} - LIST`}
            {...props}
            ></IrtizaDynamicInputList>
            
            );
}



export default VoucherInput;
